var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { Component } from 'react';
import { withContext } from "../../componentWrappers";
import { advancedSort } from "../../utils/advancedSort";
import { Translate } from "../../I18N";


import UploadButton from "../../Metadata/components/UploadButton";
import { LanguageUtils } from "../../../shared/language";
import { NeedAuthorization } from "../../Auth";
import { ConnectedFile as File } from "./File";
import "./scss/filelist.scss";

const defaultProps = {
  files: [],
  storeKey: '',
  entity: {},
  readonly: false
};









const orderFilesByLanguage = (files, systemLanguage) => {
  const orderedFiles = [...files];
  const fileIndex = orderedFiles.findIndex((file) => {var _LanguageUtils$fromIS;
    const language = (_LanguageUtils$fromIS = LanguageUtils.fromISO639_3(file.language)) === null || _LanguageUtils$fromIS === void 0 ? void 0 : _LanguageUtils$fromIS.ISO639_1;
    return language === systemLanguage;
  });
  if (fileIndex > -1) {
    const temp = orderedFiles[fileIndex];
    [orderedFiles[fileIndex]] = orderedFiles;
    orderedFiles[0] = temp;
  }
  return orderedFiles;
};

export class FileList extends Component {
  static arrangeFiles(files = []) {
    return advancedSort(files, { property: 'originalname' });
  }



  renderFile(file, index) {
    const { entity = {} } = this.props;
    return (/*#__PURE__*/
      _jsx("li", {}, index, /*#__PURE__*/
      _jsx(File, {
        file: file,
        entity: entity,
        readonly: this.props.readonly,
        mainContext: this.props.mainContext }
      )
      ));

  }

  render() {
    const label = /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Primary Documents")
    );


    const { files, storeKey, readonly, entity = {} } = this.props;
    const orderedFiles = orderFilesByLanguage(files, entity.language);
    return (/*#__PURE__*/
      _jsx("div", { className: "filelist" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "filelist-header" }, void 0,
      orderedFiles.length === 0 ? /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0,
      label
      ) : /*#__PURE__*/

      React.createElement(React.Fragment, null, label),

      !readonly && /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0, /*#__PURE__*/
      _jsx(UploadButton, { entitySharedId: entity.sharedId, storeKey: storeKey })
      )
      )

      ), /*#__PURE__*/
      _jsx("ul", {}, void 0, orderedFiles.map((file, index) => this.renderFile(file, index)))
      ));

  }
}_defineProperty(FileList, "defaultProps", defaultProps);

export default withContext(FileList);